import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  inject,
  HostListener,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { MatOptionModule } from '@angular/material/core';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { DepartmentsService } from '../../features/departments/services/departments.service';
import { TasksService } from '../../features/tasks/services/tasks.service';
import { ActivatedRoute, Router } from '@angular/router';
import { nonNegativeValidator } from '../../shared/services/validations';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-branch',
  standalone: true,
  imports: [
    LayoutComponent,
    AgGridAngular,
    MatButtonModule,
    MatDialogModule,
    CommonModule
  ],
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
})
export class TaskComponent {
  public viewPortSize: boolean = false;
  public rowData: any[] = [];

  canAddTask$ = this.permissionsService.hasPermission(
    ModuleIds.TaskManagement,
    'Create'
  );
  canEditTask$ = this.permissionsService.hasPermission(
    ModuleIds.TaskManagement,
    'Edit'
  );
  canDeleteTask$ = this.permissionsService.hasPermission(
    ModuleIds.TaskManagement,
    'Delete'
  );

  canEditTask: boolean = false;
  canDeleteTask: boolean = false;

  public columnDefs: ColDef[] = [
    {
      field: 'departmentName',
      headerName: 'Department Name',
      flex: this.viewPortSize ? 1 : 0,
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: this.viewPortSize ? 1 : 0,
      cellRenderer: (params: any) => {
        const div = document.createElement('div');
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.gap = '20px';

        const createButton = (iconSrc: string, onClick: () => void) => {
          const span = document.createElement('span');
          span.style.cursor = 'pointer';
          span.style.display = 'flex';
          span.innerHTML = `<img src="${iconSrc}"/>`;
          span.addEventListener('click', onClick);
          return span;
        };
        // div.appendChild(createButton('assets/images/icons/icon-edit.svg', () => this.openEditDialog(params ?. data)));
        // if(this.profileName === 'admin'){
        // div.appendChild(createButton('assets/images/icons/icon-delete.svg', () => this.onDeleteBranch(params.data ?. id)));
        // }
        // this.store.select(selectPermissions.hasPermission('28', Permission.Edit)).subscribe((canEdit) => {
        //     if (canEdit) {
        div.appendChild(
          createButton('assets/images/icons/icon-edit.svg', () =>
            this.openEditDialog(params?.data)
          )
        );
        //     }
        //   });
        // this.store.select(selectPermissions.hasPermission('28', Permission.Delete)).subscribe((canDelete) => {
        //     if (canDelete) {
        div.appendChild(
          createButton('assets/images/icons/icon-delete.svg', () =>
            this.onDeleteTask(params.data?.id)
          )
        );
        //     }
        //   });
        return div;
      },
      floatingFilter: false,
      filter: false,
    },
  ];
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public themeClass: string = 'ag-theme-quartz';
  public loading: boolean = true;
  public error: any = null;

  private searchSubject = new Subject<string>();
  profileName: any;

  constructor(
    private taskService: TasksService,
    private toastr: ToastrService,
    private route: Router,
    private permissionsService: PermissionService
  ) {
    const loggedInUser: any = localStorage.getItem('loggedInUser');
    const userData = JSON.parse(loggedInUser);
    this.profileName = userData?.profileData?.profileName;
  }

  ngOnInit() {
    this.fetchTasks();

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchTasks(searchTerm);
      });

      this.canEditTask$.subscribe((canEdit) => {
        this.canEditTask = canEdit;
      });
      this.canDeleteTask$.subscribe((canDelete) => {
        this.canDeleteTask = canDelete;
      });

    this.checkViewportSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        field: 'taskName',
        headerName: 'Task Name',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        field: 'taskCode',
        headerName: 'Task Code',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        field: 'action',
        headerName: 'Action',
        // flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const div = document.createElement('div');
          div.style.display = 'flex';
          div.style.alignItems = 'center';
          div.style.gap = '20px';

          const createButton = (iconSrc: string, onClick: () => void) => {
            const span = document.createElement('span');
            span.style.cursor = 'pointer';
            span.style.display = 'flex';
            span.innerHTML = `<img src="${iconSrc}"/>`;
            span.addEventListener('click', onClick);
            return span;
          };

          if(this.canEditTask){
            div.appendChild(
              createButton('assets/images/icons/icon-edit.svg', () =>
                this.openEditDialog(params?.data?.id)
              )
            );
          }

          if(this.canDeleteTask){
            div.appendChild(
              createButton('assets/images/icons/icon-delete.svg', () =>
                this.onDeleteTask(params.data?.id)
              )
            );
          }
          return div;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }

  onDeleteTask(taskId: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteTask(taskId);
      }
    });
  }

  private deleteTask(taskId: number): void {
    this.taskService.removeTask(taskId).subscribe({
      next: (resp) => {
        this.toastr.success('Task deleted successfully');
        this.fetchTasks();
      },
      error: (error: any) => {
        this.toastr.error(error, 'Error');
        this.loading = false;
      },
    });
  }

  private fetchTasks(search: string = '') {
    this.loading = true;
    this.taskService.fetchTasks(search).subscribe({
      next: (tasks) => {
        this.rowData = tasks.map((task: any) => {
          return {
            id: task?.id || '--',
            taskName: task?.taskName || '--',
            taskCode: task?.taskCode || '--',
            // price: task?.price || '--',
            // estimatedTime: task?.estimatedTime || '--',
          };
        });

        this.loading = false;
      },
      error: (error) => {
        this.error = error;
        this.loading = false;
      },
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  readonly dialog = inject(MatDialog);

  openConfirm() {
    const dialogRef = this.dialog.open(ConfirmDialog);
  }

  openDialog() {
    this.route.navigate(['tasks/add-tasks']);
  }

  openEditDialog(taskId: any) {
    this.route.navigate(['tasks/edit-task', taskId]);
  }
}

const gridDiv = document.querySelector<HTMLElement>('#myGrid')!;

@Component({
  selector: 'add-branch-dialog',
  templateUrl: './add-tasks.html',
  styleUrls: ['./tasks.component.scss'],
  standalone: true,
  imports: [
    // MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatOptionModule,
    CommonModule,
  ],
})
export class AddTaskComponent implements OnInit {
  @Output() branchAdded = new EventEmitter<any>();
  taskForm!: FormGroup;
  variantForm: FormGroup;
  itemArray: any[] = [];
  variantArray: any[] = [];
  taskData: any;
  loading: boolean = false;
  editVariantIndex: number | null = null;
  editChecklistIndex: number | null = null;  
  taskId: string | null;
  readonly dialog = inject(MatDialog);

  constructor(
    private taskService: TasksService,
    private toastr: ToastrService,
    private http: HttpClient,
    private fb: FormBuilder,
    private route: Router,
    private router: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.router.paramMap.subscribe((params) => {
      this.taskId = params.get('id');
      this.fetchTaskById(Number(this.taskId));
    });
  }

  initForm(): void {
    this.taskForm = this.fb.group({
      taskName: [this.taskData?.taskName || '', Validators.required],
      taskCode: [this.taskData?.taskCode || '', Validators.required],
      itemName: [''],
      variants: this.fb.array([]),
    });

    this.variantForm = this.fb.group({
      id: [''],
      variantName: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(0)]],
      estimatedTime: ['', [Validators.required, Validators.min(0)]],
    });
  }

  get variantsFormArray(): FormArray {
    return this.taskForm.get('variants') as FormArray;
  }

  addChecklist(itemName: any) {
    if (!itemName?.trim()) return;

    if (this.taskForm.invalid) {
      this.taskForm.markAllAsTouched();
      return;
    }

    if (this.editChecklistIndex !== null) {
      let existingItem = { ...this.itemArray[this.editChecklistIndex] };

      // Remove __typename if it exists
      const { __typename, ...cleanItem } = existingItem;

      const updatedItem = { ...cleanItem, itemName };
      this.itemArray = this.itemArray.map((item, index) =>
        index === this.editChecklistIndex ? updatedItem : item
      );

      this.editChecklistIndex = null;
    } else {
      const newItem = { itemName };
      this.itemArray = [...this.itemArray, newItem];
    }

    this.taskForm.get('itemName')?.reset();
  }

  // Add or Update variant
  saveVariant(): void {
    if(this.variantForm.invalid) {
      this.variantForm.markAllAsTouched();
      return;
    }
    if (this.variantForm.valid) {
      const updatedVariant = this.fb.group({
        id: [this.variantForm.value.id || null],
        variantName: [this.variantForm.value.variantName, Validators.required],
        price: [
          this.variantForm.value.price,
          [Validators.required, Validators.min(0)],
        ],
        estimatedTime: [
          this.variantForm.value.estimatedTime,
          [Validators.required, Validators.min(0)],
        ],
      });

      console.log('this.editVariantIndex',this.editVariantIndex);
      

      if (this.editVariantIndex !== null) {
        // Update existing variant
        this.variantsFormArray.setControl(this.editVariantIndex, updatedVariant);
        this.editVariantIndex = null; // Exit edit mode
      } else {
        // Add new variant
        this.variantsFormArray.push(updatedVariant);
      }

  
      

      this.variantForm.reset(); // Clear form
    } else {
      this.variantForm.markAllAsTouched();
    }
  }

  fetchTaskById(id: any) {
    if (id) {
      this.taskService.fetchTaskById(id).subscribe({
        next: (tasks) => {
          this.taskData = tasks;
          this.itemArray = tasks?.taskCheckListItems || [];
          this.initForm();
          if (tasks?.taskVariants?.length) {
            tasks.taskVariants.forEach((variant: any) => {
              const variantGroup = this.fb.group({
                id: [variant.id],
                variantName: [variant.variantName, Validators.required],
                price: [
                  variant.price,
                  [Validators.required, Validators.min(0)],
                ],
                estimatedTime: [
                  variant.estimatedTime,
                  [Validators.required, Validators.min(0)],
                ],
              });

              this.variantsFormArray.push(
                variantGroup
              );

              console.log('this.variantsFormArray',this.variantsFormArray);
              
              
            });
          }
        },
        error: (error) => {
          this.toastr.error(error, 'Error');
        },
      });
    }
  }

  removeVariant(index: number): void {
    const variant = this.variantsFormArray.at(index)?.value;

    if (variant?.id) {
      const dialogRef = this.dialog.open(ConfirmDialog);

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result === true) {
          this.taskService
            .removeTaskVariantItem(Number(variant?.id))
            .subscribe({
              next: () => {
                // On successful deletion from backend, remove from UI
                this.variantsFormArray.removeAt(index);
                this.toastr.success('Variant deleted successfully');
              },
              error: (err) => {
                console.error('Failed to delete variant:', err);
                this.toastr.error('Failed to delete variant');
              },
            });
        }
      });
    } else {
      // Variant is not saved yet, just remove from FormArray
      this.variantsFormArray.removeAt(index);
    }
  }

  onEditVariant(index: number): void {
    console.log('this.variantsFormArray',this.variantsFormArray);
    
    const selectedVariant = this.variantsFormArray.at(index);
    
    if (selectedVariant) {
      console.log('selectedVariant',selectedVariant);
      this.variantForm.patchValue({
        id: selectedVariant.value?.id || null,
        variantName: selectedVariant.get('variantName')?.value,
        price: selectedVariant.get('price')?.value,
        estimatedTime: selectedVariant.get('estimatedTime')?.value,
      });
      console.log('this.variantForm',this.variantForm);
      this.editVariantIndex = index;

      
    }
  }

  onEditItem(id: any) {
    const item = this.itemArray[id];
    this.taskForm.get('itemName')?.setValue(item?.itemName);
    this.editChecklistIndex = id;
  }

  onRemoveItem(id: number) {
    if (this.taskData?.id && this.itemArray[id]?.id) {
      const dialogRef = this.dialog.open(ConfirmDialog);

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result === true) {
          this.taskService
            .removeTaskCheckListItem(this.itemArray[id]?.id)
            .subscribe({
              next: () => {
                this.toastr.success('Item removed successfully!', 'Success');
                this.itemArray = this.itemArray
                  .filter((_, index) => index !== id)
                  .map(({ __typename, ...rest }) => rest);
              },
              error: (error) => {
                this.toastr.error(error, 'Error');
                this.loading = false;
              },
            });
        }
      });
    } else {
      // New item, remove safely
      this.itemArray = this.itemArray.filter((_, index) => index !== id);
    }

    // Reset form if the removed item was being edited
    if (this.editChecklistIndex === id) {
      this.taskForm.get('itemName')?.reset();
      this.editChecklistIndex = null;
    }
  }

  onAddTask(): void {
    if (this.taskForm.invalid) {
      this.taskForm.markAllAsTouched();
      return;
    }

    if (this.variantsFormArray.length <= 0) {
      this.toastr.warning('Please add at least one variant', 'Error');
      return;
    }

    if (!this.taskData) {
      this.loading = true;
      const createTaskInput = {
        taskName: this.taskForm.value.taskName,
        taskCode: this.taskForm.value.taskCode,
      };
      const taskCheckListItems = this.itemArray;
      const taskVariants: any = this.variantsFormArray.value;
      const cleanedVariants: any = taskVariants.map(({ id, ...rest }: any) => rest);


      console.log('cleanedVariants',taskVariants);
      
      
      this.taskService
        .createTask(createTaskInput, taskCheckListItems, cleanedVariants)
        .subscribe(
          (response) => {
            this.loading = false;
            this.toastr.success('Task added successfully!', 'Success');
            this.variantForm.reset();
            this.taskForm.reset();
            this.route.navigate(['/tasks']);
          },
          (error) => {
            this.loading = false;
            let errorMessage = 'Failed to add task. Please try again.';

            this.toastr.error(errorMessage, 'Error');
          }
        );
    } else {
      this.taskForm.markAllAsTouched();
      if (this.taskForm.valid) {
        this.loading = true;
        const updateTaskInput = {
          id: Number(this.taskId),
          taskName: this.taskForm.value.taskName,
          taskCode: this.taskForm.value.taskCode,
        };
        const taskCheckListItems = this.itemArray.map(
          ({ __typename, ...rest }) => rest
        );
        const taskVariants = this.variantsFormArray.value;

        console.log('taskVariants',taskVariants);
        
        this.taskService
          .updateTask(updateTaskInput, taskCheckListItems, taskVariants)
          .subscribe(
            (response) => {
              this.loading = false;
              this.toastr.success('Task updated successfully!', 'Success');
              this.route.navigate(['/tasks']);
            },
            (error) => {
              this.loading = false;
              let errorMessage = 'Failed to update task. Please try again.';
              this.toastr.error(errorMessage, 'Error');
            }
          );
      }
    }
  }
}
